import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getStudents(filters: any) {
  const params = new URLSearchParams();

  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  if (filters.rol_id) params.set('rol_id', filters.rol_id);
  const response = await axios.get(
    `${API_URL}reports/students?sort=id&${params.toString()}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function downloadPDF(filters: any) {
  const date = new Date().toISOString().split('T')[0];
  const params = new URLSearchParams({ sort: 'id' });

  if (filters.type_id && filters.type_id !== 0) {
    params.append('type_id', filters.type_id.toString());
  }
  if (filters.init_date) {
    params.append('init_date', filters.init_date);
  }
  if (filters.end_date) {
    params.append('end_date', filters.end_date);
  }

  try {
    const response = await axios.get(
      `${API_URL}reports/students/document/pdf?${params.toString()}`,
      { responseType: 'blob' }
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-ESTUDIANTES-${date}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error: any) {
    const errorData = await error.response?.data?.text?.();
    return errorData ? JSON.parse(errorData) : { message: 'Error inesperado' };
  }
}

export async function downloadExcel(filters: any) {
  let search: string = '';
  let date = new Date().toISOString().split('T')[0];

  if (filters.init_date) {
    search += `&init_date=${filters.init_date}`;
  }
  if (filters.end_date) {
    search += `&end_date=${filters.end_date}`;
  }
  const response = await axios({
    url: `${API_URL}reports/students/document/excel?${search}`,
    method: 'GET',
    responseType: 'blob',
  })
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `REPORTE-ESTUDIANTES-${date}.xlsx`);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 0);
      return false;
    })
    .catch(async (error) => {
      return JSON.parse(await error.response.data.text());
    });
  return response;
}
